 @if (booking?.Status == 0 || booking?.Status == 50) {
 @if (toFarAway && (!booking.IsOneWay && booking?.Status == 0)) {
 @if (booking) {
<h2>{{ booking.PickupLocation.Name }}</h2>
 }
<app-card>
  <div #gmap id="map"></div>
  <p id="text-red"><strong>{{'Intellitrailer.Rental.BookingInfo.GoToLocationPrompt' | translate : 'Go to {0} to start your rent' : [booking?.PickupLocation?.Name] }}</strong></p>

  @if(canChangeBooking){
  <div class="row">
    <div class="col-6">
      <button id="cancel" type="button" (click)="sendRentalAction('cancelBooking')" mat-button>
        {{ 'Intellitrailer.MyPage.BookingOverview.CancelBooking' | translate : 'Cancel booking' }}
      </button>
    </div>
    <div class="col-6">
      <button id="cancel" type="button" (click)="sendRentalAction('changeBooking')" mat-button>
        {{ 'Intellitrailer.MyPage.BookingOverview.ChangeBooking' | translate : 'Change booking' }}
      </button>
    </div>
  </div>
  }
</app-card>
 } @else {
 @if (booking) {
<h2>
  {{ 'Intellitrailer.Booking.Components.BookingSummary.Trailer' | translate : 'Trailer' }}:
  @if(booking.IsOneWay){
  {{ booking.RentalObject?.Alias ?? booking.RentalObject?.Title }}
  }
  @else if (isNuwiel) {
  {{ booking.RentalObject?.Alias ?? booking.RentalObject?.Title ?? '---' }}
  }
  @else {
  {{ booking.RentalObject?.Title && booking.RentalObject?.Alias ? booking.RentalObject.Title + ' - ' + booking.RentalObject.Alias : booking.RentalObject?.Title || booking.RentalObject?.Alias || '---' }}
  }
</h2>
<app-card>
  <img src="{{ booking.PrimaryType.PictureUri }}" />
  <div class="row">
    <div class="col-4">
      <small><strong>{{ 'turbo.core.RentalDialog.Pickup' | translate : 'Pickup' }}</strong></small>
      <p>{{ booking.PickupTime | date : 'd MMM' | transliterate }} {{ booking.PickupTime | date : 'HH:mm' | transliterate  }}</p>
    </div>
    <div class="col-4">
      <mat-icon class="rtl-rotate">arrow_right_alt</mat-icon>
    </div>
    <div class="col-4">
      <small><strong>{{ 'turbo.core.RentalDialog.Return' | translate : 'Return' }}</strong></small>
      <p>{{ booking.ReturnTime | date : 'd MMM' | transliterate }} {{ booking.ReturnTime | date : 'HH:mm' | transliterate }}</p>
    </div>
  </div>
  <small><strong>{{ 'Intellitrailer.Booking.Components.BookingSummary.RentalLocation' | translate : 'Rental location' }}</strong></small>
  <p>{{ booking.PickupLocation.Name }}</p>

  @if (appService.Device.Location < 3 && !toEarly) {
  <p id="text-red">
    {{'Intellitrailer.AllowLocationAccessInfo.NolocationAccessText' | translate : 'You have not provided access to your devices location. We cannot determine that you are in the correct place to pickup your trailer.'}}
  </p>
  <!-- Always allow starting rent even without GPS -->
  <button (click)="sendRentalAction('start')" mat-raised-button color="primary">
    {{ 'Intellitrailer.Rental.Components.RentalBox.StartRent' | translate : 'Start rent' }}
  </button>
  }
  @else {
  @if(toEarly && booking?.IsOneWay && booking?.Status == 0){
  @if(onewayStatus == 0) {
  <strong>{{'Intellitrailer.MyPage.BookingOverview.valStatus0' | translate : 'Preliminary' }}</strong>
  <p>
    {{'Intellitrailer.MyPage.BookingOverview.lblEstimatedConfirmationDate' | translate : 'Estimated confirmation date' }}<br />
    {{ bookingQueue.BindsAt | date : 'yyyy-MM-dd' | transliterate }}
  </p>
  }
  @if (onewayStatus == 2) {
  <p>{{'Intellitrailer.MyPage.BookingOverview.lblOneWayNoTrailerEstimated' | translate: 'We are actively looking for a trailer for you and hope to find a solution as soon as possible.'}}</p>
  }
  }
  @else if (toEarly) {
  <p id="text-red">
    <strong>{{'Intellitrailer.Rental.BookingInfo.ReadyForPickup' | translate : 'Ready for pickup' }} {{ pCountdown.locale(appSettings.getLanguage()).humanize(true) }}</strong>
  </p>

  @if (available && !toFarAway) {
  <button (click)="pickupNow()" mat-raised-button color="primary">
    {{ 'Intellitrailer.Booking.Components.BookingSummary.StartNow' | translate : 'Start Now' }}
  </button>
  }
  }
  @else {
  @if (!toFarAway) {
  @if (allowUnmanned || isNuwiel) {
  <button (click)="sendRentalAction('start')" mat-raised-button color="primary">
    {{ 'Intellitrailer.Rental.Components.RentalBox.StartRent' | translate : 'Start rent' }}
  </button>
  }
  @else {
  @if (!isElecticBike) {
  <p id="text-red">
    {{'Intellitrailer.Rental.BookingInfo.EnterStoreInfo' | translate : 'Enter the store to sign the rental contract and get access to keys to the vehicle'}}
  </p>
  }
  @else {
  <p id="text-red">
    {{
'Intellitrailer.Rental.BookingInfo.EnterStoreInfoBike' | translate : 'Enter the store and talk to the personnel to start the rent and get access to the keys, helmet and battery for the bike'
    }}
  </p>
  }
  }
  }
  }
  }

  @if(canChangeBooking){
  @if(booking.IsOneWay){
  <div class="row">
    <div class="col-12">
      <button id="cancel" type="button" (click)="sendRentalAction('cancelBooking')" mat-button>
        {{ 'Intellitrailer.MyPage.BookingOverview.CancelBooking' | translate : 'Cancel booking' }}
      </button>
    </div>
  </div>
  }
  @else{
  <div class="row">
    <div class="col-6">
      <button id="cancel" type="button" (click)="sendRentalAction('cancelBooking')" mat-button>
        {{ 'Intellitrailer.MyPage.BookingOverview.CancelBooking' | translate : 'Cancel booking' }}
      </button>
    </div>
    <div class="col-6">
      <button id="cancel" type="button" (click)="sendRentalAction('changeBooking')" mat-button>
        {{ 'Intellitrailer.MyPage.BookingOverview.ChangeBooking' | translate : 'Change booking' }}
      </button>
    </div>
  </div>
  }
  }
</app-card>
  }
 }
 }

  @if (booking?.Status == 100 || booking?.Status == 150) {
  @if (booking) {
<h2>
  {{ 'Intellitrailer.Booking.Components.BookingSummary.Trailer' | translate : 'Trailer'}}:
  {{ booking.RentalObject?.Title }}
</h2>
<app-card>
  <img src="{{ booking.PrimaryType.PictureUri }}" />
  <br />
  <small><strong>{{ 'Intellitrailer.Rental.Components.RentalBox.ReturnTo' | translate : 'Return to' }}</strong></small>
  <p>
    {{ booking.ReturnLocation.Name }}<br />
    {{ booking.ReturnLocation.Address }}
  </p>

  @if (!late) {
  <h2><strong>{{ 'Intellitrailer.Rental.InFlight.TimeLeft' | translate : 'TimeLeft' }}</strong></h2>
  } @else {
  <p id="text-red">
    <strong>{{ 'Intellitrailer.Rental.InFlight.Delayed' | translate : 'Delayed' }}</strong>
  </p>
  }
  <p id="text-red">
    {{ rCountdown?.locale(Settings.clientSettings.Language).humanize() }}
    ({{ booking.ReturnTime | date : 'd MMM' }} {{ booking.ReturnTime | date : 'HH:mm' }})
  </p>

  @if (late) {
  <p id="text-red-small">
    <strong>{{ 'Intellitrailer.Rental.InFlight.msgLateExtensions' | translate : 'Extension is not allowed due to delayed booking' }}</strong>
  </p>
  }
  @else if (isVarebil) {
  <p id="text-red-small">
    <strong>{{ 'Intellitrailer.Rental.InFlight.msgLateExtensionVarebil' | translate : 'Extension is not allowed for Varebil rentals' }}</strong>
  </p>
  }

  <div class="row justify-content-center">
    @if (hasLock) {
    <div class="col-6">
      <button id="cmdUnlock" (click)="sendRentalAction('unlock')" mat-raised-button color="primary">
        <mat-icon>lock_open</mat-icon>
      </button>
      <div>{{ 'Intellitrailer.Rental.InFlight.Unlock' | translate : 'Unlock' }}</div>
    </div>
    }
    @if (isNuwiel && !isPickup) {
    <div class="col-4 nuwiel-col">
      <button id="cmdUnlock" (click)="sendRentalAction('nuwiel')" mat-raised-button color="primary">
        <mat-icon>library_books</mat-icon>
      </button>
      <div>{{ 'Intellitrailer.Rental.InFlight.NuwielInstructions' | translate : 'Instructions' }}</div>
    </div>
    <div class="col-4 nuwiel-col">
      <button id="cmdUnlock" (click)="sendRentalAction('nuwiel-park')" mat-raised-button color="primary">
        <mat-icon>local_parking</mat-icon>
      </button>
      <div>{{ 'Intellitrailer.Rental.InFlight.NuwielParking' | translate : 'Parking' }}</div>
    </div>
    <div class="col-4 nuwiel-col">
      <button id="cmdUnlock" [disabled]="late || isVarebil" (click)="sendRentalAction('extend')" mat-raised-button color="primary">
        <mat-icon>update</mat-icon>
      </button>
      <div>{{ 'Intellitrailer.Rental.InFlight.Extend' | translate : 'Extend' }}</div>
    </div>
    }
    @else {
    <div class="col-6">
      <button id="cmdUnlock" [disabled]="late || isVarebil" (click)="sendRentalAction('extend')" mat-raised-button color="primary">
        <mat-icon>update</mat-icon>
      </button>
      <div>{{ 'Intellitrailer.Rental.InFlight.Extend' | translate : 'Extend' }}</div>
    </div>
    }
  </div>

  <div>
    @if (!allowUnmanned && !isElecticBike) {
    <span>
      {{ 'Intellitrailer.Rental.BookingInfo.EnterStoreInfoReturn' | translate : 'Enter the store to complete the return process and return the keys to the vehicle' }}
    </span>
    } @else if (!allowUnmanned && isElecticBike) {
    <span>
      {{ 'Intellitrailer.Rental.BookingInfo.EnterStoreInfoReturnBike' | translate : 'Enter the store and return the keys, helmet and battery for the bike to complete the return process' }}
    </span>
    }
    <!--@else if (allowUnmanned) {
    <button (click)="sendRentalAction('return')" mat-raised-button>
      {{ 'Intellitrailer.Rental.InFlight.TerminateRent' | translate : 'Terminate rent' }}
    </button>
    }-->
  </div>
</app-card>
  }
  }
